import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { footerHandlers } from "./footerHandlers";
import { headerHandlers } from "./headerHandlers";
import { metaHandler } from "./metaHandler";
export var handlers = [].concat(_toConsumableArray(footerHandlers), _toConsumableArray(headerHandlers), _toConsumableArray(metaHandler));